"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArithmeticOpcodeTemplates = getArithmeticOpcodeTemplates;
function getArithmeticOpcodeTemplates() {
    return `
                        // Arithmetic Operations
                        case opMap[10]: { // ADD
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a + b);
                            pc++;
                            break;
                        }

                        case opMap[11]: { // SUB
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a - b);
                            pc++;
                            break;
                        }

                        case opMap[12]: { // MUL
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a * b);
                            pc++;
                            break;
                        }

                        case opMap[13]: { // DIV
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a / b);
                            pc++;
                            break;
                        }

                        case opMap[14]: { // MOD
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a % b);
                            pc++;
                            break;
                        }

                        case opMap[15]: // NEG
                            stack.push(-stack.pop());
                            pc++;
                            break;

                        case opMap[19]: // UNARY_PLUS - convert to number
                            stack.push(+stack.pop());
                            pc++;
                            break;

                        case opMap[18]: { // EXPONENT
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(Math.pow(a, b));
                            pc++;
                            break;
                        }
    `;
}
